import { render, staticRenderFns } from "./EmployeesNew.vue?vue&type=template&id=7d1f3a82"
import script from "./EmployeesNew.vue?vue&type=script&lang=js"
export * from "./EmployeesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports